import { createContext, useContext } from 'react';

type LoadingContextType = {
    isLoading: boolean;
    setLoading: (loading: boolean) => void;
};

export const LoadingContext = createContext<LoadingContextType | undefined>(
    undefined,
);

export const loadingManager = {
    start: () => {},
    stop: () => {},
};

export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};
